// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__nCxey","linkList":"Footer_linkList__vzVYs"};